module.exports = __webpack_public_path__ + "static/media/DrawTile.fa589c05.jpg";